import { Button, ButtonsGroup, Footer, Price } from "#/atoms";
import { FC, memo, useState } from "react";
import { FONT_SIZE, FONT_WEIGHT } from "@/theme";

import { ORDER_STEP } from "../Order/Order.interface";
import { PackageName } from "#/molecules";
import { SelectedOrderProps } from "./SelectedOrder.interface";

const getButtonLabel = (activeStep: ORDER_STEP) => {
  switch (activeStep) {
    case ORDER_STEP.BOOKING: {
      return 'Place Order';
    }
    case ORDER_STEP.PROGRESS: {
      return 'Save Order';
    }
    case ORDER_STEP.CUSTOMER_AND_PACKAGE: {
      return 'Place Order';
    }
    case ORDER_STEP.CONTENT_SELECTION: {
      return 'Continue with the selection';
    }
  }
}

const SelectedOrder: FC<SelectedOrderProps> = ({
  activeStep,
  description,
  extraText,
  id,
  isAdmin,
  isReadOnly,
  invoiceOverride = false,
  price,
  onDeleteOrder,
  onCancelOrder,
  onMarkForInvoicing,
  onSaveOrder,
}) => {
   const [hasInvoiceOverride, setHasInvoiceOverride] = useState(invoiceOverride);

   const getMarkForInvoicingLabel = () => {
    return hasInvoiceOverride ? 'Unmark for invoicing' : 'Mark for invoicing';
  }

  const handleMarkForInvoicing = () => {
    setHasInvoiceOverride(!hasInvoiceOverride);
    onMarkForInvoicing?.();
  }

  return (
    <Footer>
      {!isReadOnly && <PackageName icons={[]} id={id} name={description} /> }
      <Price amount={price} currency="GBP" fontSize={FONT_SIZE.LG} fontWeight={FONT_WEIGHT.SEMIBOLD} extraText={extraText} />
      {!isReadOnly && <ButtonsGroup fullWidth>
        {(isAdmin && (activeStep === ORDER_STEP.PROGRESS)) && (
          <>
            <Button onClick={handleMarkForInvoicing}>{getMarkForInvoicingLabel()}</Button>
            <Button actionType="outline" buttonColor="secondary" onClick={onCancelOrder}>
              Cancel Order
            </Button>
            <Button actionType="outline" buttonColor="secondary" onClick={onDeleteOrder}>
              Delete Order
            </Button>
          </>
        )}
        <Button onClick={onSaveOrder}>{getButtonLabel(activeStep)}</Button>
        <div style={{width: '30px'}}></div>
      </ButtonsGroup>}
    </Footer>
  );
};

export default memo(SelectedOrder);